import { ANALYTICS_VIEW, IChartData, IChartDataOrbit, IChartDataSignal } from "../interfaces";
import { ITableData } from "../components/table/interfaces";

type TChartSeries = Pick<IChartData | IChartDataSignal | IChartDataOrbit, "items">;
type TChartSeriesItem<T extends TChartSeries> = T | null | undefined;

export const hasChartSeriesData = <T extends TChartSeries>(data: TChartSeriesItem<T>[] | null | undefined): boolean =>
  data?.some(series => (series?.items?.length ?? 0) > 0) ?? false;

export const hasTableRowsData = (data: ITableData | null | undefined): data is ITableData =>
  !!data?.rows.length &&
  data.items.some(
    item => item.values.some(value => value !== null) || (item.values2?.some(value => value !== null) ?? false),
  );

export const hasTrendTableExportData = (
  chartData: IChartData[] | null | undefined,
  tableData: ITableData | null | undefined,
): boolean => hasChartSeriesData(chartData) && hasTableRowsData(tableData);

export interface IAnalyticsDataAvailability {
  chartData?: IChartData[] | null;
  tableData?: ITableData | null;
  chartDataSignal?: IChartDataSignal[] | null;
  chartDataOrbit?: IChartDataOrbit[] | null;
}

export const hasAnalyticsChartData = ({
  chartData,
  chartDataSignal,
  chartDataOrbit,
}: IAnalyticsDataAvailability): boolean =>
  hasChartSeriesData(chartData) || hasChartSeriesData(chartDataSignal) || hasChartSeriesData(chartDataOrbit);

export const hasAnalyticsDisplayData = (view: ANALYTICS_VIEW, data: IAnalyticsDataAvailability): boolean =>
  view === ANALYTICS_VIEW.CHART ? hasAnalyticsChartData(data) : hasTableRowsData(data.tableData);
